const REQUIRED_GROUPS = ['color', 'radius', 'space', 'size', 'shadow', 'font']

function isPlainObject(value) {
  return value != null && typeof value === 'object' && !Array.isArray(value)
}

function kebabCase(key) {
  return String(key)
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .toLowerCase()
}

function walkTokens(value, path = [], output = {}) {
  if (!isPlainObject(value)) {
    output[`--${path.map(kebabCase).join('-')}`] = String(value)
    return output
  }

  Object.entries(value).forEach(([key, nestedValue]) => {
    walkTokens(nestedValue, [...path, key], output)
  })

  return output
}

export function flattenThemeTokens(tokens) {
  return walkTokens(tokens)
}

export function validateThemeTokens(tokens) {
  REQUIRED_GROUPS.forEach((group) => {
    if (!isPlainObject(tokens?.[group])) {
      throw new Error(`Theme tokens missing required group "${group}"`)
    }
  })

  return true
}

export function createThemePreset(preset) {
  if (!preset?.id || !preset?.label || !isPlainObject(preset?.modes)) {
    throw new Error('Theme preset must include id, label, and modes')
  }

  Object.entries(preset.modes).forEach(([mode, tokens]) => {
    validateThemeTokens(tokens)

    if (!['light', 'dark'].includes(mode)) {
      throw new Error(`Unsupported theme mode "${mode}"`)
    }
  })

  return preset
}
